/**
 * Humanized display labels for LetterSection.section_key (UI-SPEC §1).
 * Pure module — no axios, no React.
 */
const sectionLabels = {
  opening: 'Opening',
  denial_response: 'Denial response',
  medical_necessity: 'Medical necessity',
  treatment_rationale: 'Treatment rationale',
  supporting_docs_summary: 'Supporting documents',
  requested_action: 'Requested action',
  closing: 'Closing',
};

/**
 * Label lookup with a snake_case → Sentence case fallback so unknown
 * section keys still render something readable.
 * @param {string} key
 * @returns {string}
 */
export function labelForSectionKey(key) {
  if (sectionLabels[key]) return sectionLabels[key];
  const words = String(key || '').replace(/_/g, ' ').trim();
  if (!words) return '';
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export default sectionLabels;
